/**
 * @generated SignedSource<<723d3f94879481f401958d8d4af9132a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkTxnsInternalInputObject = {
  destinationBankAccountId?: string | null | undefined;
  destinationName?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type pnlCellPanel_MarkTxnsInternalMutation$variables = {
  input: MarkTxnsInternalInputObject;
};
export type pnlCellPanel_MarkTxnsInternalMutation$data = {
  readonly markTxnsInternal: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type pnlCellPanel_MarkTxnsInternalMutation = {
  response: pnlCellPanel_MarkTxnsInternalMutation$data;
  variables: pnlCellPanel_MarkTxnsInternalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlCellPanel_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pnlCellPanel_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1ae40b6b57c562a1edb5d778e87cb00a",
    "id": null,
    "metadata": {},
    "name": "pnlCellPanel_MarkTxnsInternalMutation",
    "operationKind": "mutation",
    "text": "mutation pnlCellPanel_MarkTxnsInternalMutation(\n  $input: MarkTxnsInternalInputObject!\n) {\n  markTxnsInternal(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8c22f6d18b0ba0701364f0ea34216b9";

export default node;
